export default "__VITE_ASSET__C6z538Ad__"